webpackJsonp([173894859265406],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebookSquare = function FaFacebookSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-4.2v-13.2h4.4l0.7-5.2h-5.1v-3.3q0-1.3 0.5-1.9t2-0.6l2.8 0v-4.7q-1.5-0.2-4-0.2-3.1 0-4.9 1.8t-1.8 5.1v3.8h-4.5v5.2h4.5v13.2h-11.9q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z' })
	        )
	    );
	};
	
	exports.default = FaFacebookSquare;
	module.exports = exports['default'];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGithub = function FaGithub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6q0 5.6-3.3 10.1t-8.4 6.2q-0.6 0.1-0.9-0.2t-0.3-0.7q0 0 0-1.7t0-3q0-2.1-1.2-3.1 1.3-0.2 2.3-0.4t2.1-0.9 1.8-1.5 1.2-2.3 0.5-3.4q0-2.7-1.8-4.6 0.8-2-0.2-4.5-0.6-0.2-1.8 0.2t-2 1l-0.9 0.5q-2-0.6-4.3-0.6t-4.2 0.6q-0.4-0.2-1-0.6t-1.9-0.8-1.9-0.3q-1 2.5-0.1 4.5-1.8 1.9-1.8 4.6 0 1.9 0.5 3.4t1.1 2.3 1.8 1.5 2.1 0.9 2.3 0.4q-0.9 0.8-1.1 2.3-0.4 0.2-1 0.3t-1.3 0.1-1.4-0.5-1.3-1.4q-0.4-0.7-1-1.1t-1.1-0.6l-0.5 0q-0.5 0-0.6 0.1t-0.1 0.2 0.2 0.3 0.2 0.3l0.2 0.1q0.5 0.2 1 0.9t0.7 1.1l0.2 0.5q0.3 0.9 1 1.4t1.5 0.7 1.5 0.1 1.3-0.1l0.5 0q0 0.8 0 1.9t0 1.2q0 0.5-0.3 0.7t-0.9 0.2q-5.2-1.7-8.4-6.2t-3.3-10.1q0-4.7 2.3-8.6t6.2-6.2 8.6-2.3z m-10.6 24.6q0.1-0.2-0.2-0.3-0.2-0.1-0.2 0.1-0.1 0.1 0.1 0.2 0.2 0.2 0.3 0z m0.7 0.7q0.1-0.1-0.1-0.3-0.2-0.2-0.3-0.1-0.2 0.1 0 0.4 0.3 0.2 0.4 0z m0.7 1q0.2-0.1 0-0.4-0.2-0.3-0.4-0.1-0.2 0.1 0 0.4t0.4 0.1z m0.9 1q0.2-0.2-0.1-0.4-0.3-0.3-0.4-0.1-0.2 0.2 0 0.4 0.3 0.3 0.5 0.1z m1.3 0.5q0-0.2-0.3-0.3-0.4-0.1-0.4 0.1t0.2 0.4q0.4 0.1 0.5-0.2z m1.4 0.1q0-0.2-0.4-0.2-0.4 0-0.4 0.2 0 0.3 0.4 0.3 0.4 0 0.4-0.3z m1.3-0.2q-0.1-0.2-0.4-0.2-0.4 0.1-0.3 0.4t0.4 0.1 0.3-0.3z' })
	        )
	    );
	};
	
	exports.default = FaGithub;
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitter = function FaTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitter;
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYoutube = function FaYoutube(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.7 27.8v4.7q0 1.5-0.9 1.5-0.5 0-1-0.5v-6.7q0.5-0.5 1-0.5 0.9 0 0.9 1.5z m7.5 0v1h-2v-1q0-1.5 1-1.5t1 1.5z m-21.5-4.9h2.3v-2.1h-6.9v2.1h2.3v12.7h2.3v-12.7z m6.4 12.7h2v-11h-2v8.4q-0.7 1-1.3 1-0.4 0-0.5-0.5 0-0.1 0-0.8v-8.1h-2v8.7q0 1.1 0.2 1.7 0.3 0.8 1.3 0.8 1.1 0 2.3-1.4v1.2z m9.6-3.3v-4.4q0-1.6-0.2-2.2-0.4-1.2-1.6-1.2-1.1 0-2.1 1.2v-4.9h-2v14.8h2v-1q1 1.2 2.1 1.2 1.2 0 1.6-1.2 0.2-0.6 0.2-2.3z m7.5-0.2v-0.3h-2q0 1.1-0.1 1.4-0.1 0.8-0.9 0.8-1 0-1-1.6v-1.9h4v-2.3q0-1.8-0.6-2.6-0.9-1.1-2.4-1.1-1.5 0-2.4 1.1-0.6 0.8-0.6 2.6v3.9q0 1.7 0.7 2.5 0.8 1.2 2.4 1.2 1.6 0 2.4-1.2 0.4-0.6 0.5-1.2 0-0.2 0-1.3z m-13.6-20.4v-4.7q0-1.5-0.9-1.5t-1 1.5v4.7q0 1.6 1 1.6t0.9-1.6z m16.1 16.8q0 5.2-0.6 7.8-0.3 1.3-1.3 2.2t-2.3 1q-4.1 0.5-12.4 0.5t-12.3-0.5q-1.3-0.1-2.3-1t-1.3-2.2q-0.6-2.5-0.6-7.8 0-5.2 0.6-7.8 0.3-1.3 1.3-2.2t2.3-1.1q4.1-0.4 12.3-0.4t12.4 0.4q1.3 0.2 2.3 1.1t1.3 2.2q0.6 2.5 0.6 7.8z m-22.3-28.5h2.3l-2.7 8.9v6.1h-2.2v-6.1q-0.4-1.6-1.4-4.7-0.8-2.3-1.5-4.2h2.4l1.6 5.9z m8.3 7.4v3.9q0 1.8-0.7 2.7-0.8 1.1-2.3 1.1-1.5 0-2.4-1.1-0.6-0.9-0.6-2.7v-3.9q0-1.8 0.6-2.6 0.9-1.1 2.4-1.1 1.5 0 2.3 1.1 0.7 0.8 0.7 2.6z m7.4-3.6v11.2h-2v-1.3q-1.2 1.4-2.3 1.4-1 0-1.3-0.8-0.2-0.5-0.2-1.7v-8.8h2v8.2q0 0.7 0.1 0.8 0 0.5 0.4 0.5 0.6 0 1.3-1v-8.5h2z' })
	        )
	    );
	};
	
	exports.default = FaYoutube;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Posts = __webpack_require__(170);
	
	var _Posts2 = _interopRequireDefault(_Posts);
	
	var _SocialLinks = __webpack_require__(130);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _Welcome = __webpack_require__(131);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _BtnLink = __webpack_require__(169);
	
	var _BtnLink2 = _interopRequireDefault(_BtnLink);
	
	var _Technologies = __webpack_require__(63);
	
	var _Technologies2 = _interopRequireDefault(_Technologies);
	
	var _Games = __webpack_require__(124);
	
	var _Games2 = _interopRequireDefault(_Games);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  var posts = props.data.allMarkdownRemark.edges.map(function (p) {
	    return p.node;
	  });
	  var langKey = props.pathContext.langKey;
	  var _props$data$site$site = props.data.site.siteMetadata.resume,
	      pinnedTechnologies = _props$data$site$site.pinnedTechnologies,
	      games = _props$data$site$site.games;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SocialLinks2.default, null),
	    _react2.default.createElement(_Welcome2.default, { currentLangKey: langKey }),
	    _react2.default.createElement(_Technologies2.default, {
	      technologies: pinnedTechnologies
	    }),
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'resume.technologies.seeMore' },
	      function (txt) {
	        return _react2.default.createElement(
	          _BtnLink2.default,
	          { to: '/' + langKey + '/resume/' },
	          txt
	        );
	      }
	    ),
	    _react2.default.createElement(_Games2.default, { games: games }),
	    _react2.default.createElement(_Posts2.default, {
	      posts: posts,
	      langKey: langKey,
	      showBtnMorePosts: true
	    })
	  );
	};
	
	Index.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  padding-top: ', ';\n  padding-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n\n  padding-top: ', ';\n  padding-bottom: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  max-width: 80%;\n  max-height: ', ';\n'], ['\n  max-width: 80%;\n  max-height: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  text-align: center;\n  padding-top: 1rem;\n'], ['\n  font-size: ', ';\n  text-align: center;\n  padding-top: 1rem;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n'], ['\n  text-align: center;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _A = __webpack_require__(35);
	
	var _A2 = _interopRequireDefault(_A);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Li = _styledComponents2.default.li(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(0);
	}, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(0);
	}, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(0);
	}, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(0);
	});
	
	var Img = _styledComponents2.default.img(_templateObject2, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(12);
	});
	
	var Figcaption = _styledComponents2.default.figcaption(_templateObject3, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.scale(0);
	});
	
	var Figure = _styledComponents2.default.figure(_templateObject4);
	
	var Game = function Game(props) {
	  var link = props.link,
	      name = props.name,
	      img = props.img;
	
	
	  return _react2.default.createElement(
	    Li,
	    null,
	    _react2.default.createElement(
	      _A2.default,
	      { href: link, target: '_blank' },
	      _react2.default.createElement(
	        Figure,
	        null,
	        _react2.default.createElement(Img, { src: '/imgs/' + img, alt: name, title: name }),
	        _react2.default.createElement(
	          Figcaption,
	          null,
	          name
	        )
	      )
	    )
	  );
	};
	
	Game.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  img: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string.isRequired
	};
	
	exports.default = Game;
	module.exports = exports['default'];

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  margin: 1rem 0 0 0;\n  padding: 0;\n'], ['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  margin: 1rem 0 0 0;\n  padding: 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Game = __webpack_require__(123);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Ul = _styledComponents2.default.ul(_templateObject);
	
	var Games = function Games(_ref) {
	  var games = _ref.games;
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'resume.games' },
	        function (txt) {
	          return _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          );
	        }
	      )
	    ),
	    _react2.default.createElement(
	      Ul,
	      null,
	      games.map(function (game, i) {
	        return _react2.default.createElement(_Game2.default, _extends({
	          key: i
	        }, game));
	      })
	    )
	  );
	};
	
	Games.propTypes = {
	  games: _propTypes2.default.array.isRequired
	};
	
	exports.default = Games;
	module.exports = exports['default'];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin: ', ';\n  padding: ', ';\n  list-style: none;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin: ', ';\n  padding: ', ';\n  list-style: none;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  text-decoration: none;\n  font-size: ', ';\n  display: inline-block;\n  margin: ', ';\n  padding: ', ';\n  transition: 0.3s;\n  \n  svg {\n    font-size: ', ';\n    display: block;\n    margin: ', ';\n    padding: ', ';\n  }\n\n  &:hover {\n    color: ', ';\n    transition: 0.3s;\n  }\n'], ['\n  color: ', ';\n  text-decoration: none;\n  font-size: ', ';\n  display: inline-block;\n  margin: ', ';\n  padding: ', ';\n  transition: 0.3s;\n  \n  svg {\n    font-size: ', ';\n    display: block;\n    margin: ', ';\n    padding: ', ';\n  }\n\n  &:hover {\n    color: ', ';\n    transition: 0.3s;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _github = __webpack_require__(39);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _youtube = __webpack_require__(165);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _facebookSquare = __webpack_require__(163);
	
	var _facebookSquare2 = _interopRequireDefault(_facebookSquare);
	
	var _twitter = __webpack_require__(164);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _pluralsightIcon = __webpack_require__(133);
	
	var _pluralsightIcon2 = _interopRequireDefault(_pluralsightIcon);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Ul = _styledComponents2.default.ul(_templateObject, function (props) {
	  return props.theme.socialLinks.margin;
	}, function (props) {
	  return props.theme.socialLinks.padding;
	});
	
	var A = _styledComponents2.default.a(_templateObject2, function (props) {
	  return props.theme.socialLinks.a.color;
	}, function (props) {
	  return props.theme.socialLinks.a.fontSize;
	}, function (props) {
	  return props.theme.socialLinks.a.margin;
	}, function (props) {
	  return props.theme.socialLinks.a.padding;
	}, function (props) {
	  return props.theme.socialLinks.a.svg.fontSize;
	}, function (props) {
	  return props.theme.socialLinks.a.svg.margin;
	}, function (props) {
	  return props.theme.socialLinks.a.svg.padding;
	}, function (props) {
	  return props.theme.socialLinks.a.hover.color;
	});
	
	var SocialLinks = function SocialLinks() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      Ul,
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          A,
	          { href: 'https://github.com/angeloocana', target: '_blank' },
	          _react2.default.createElement(_github2.default, null),
	          'Github'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          A,
	          { href: 'https://pluralsight.com/profile/ocanaangelo', target: '_blank' },
	          _react2.default.createElement(_pluralsightIcon2.default, null),
	          'Pluralsight'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          A,
	          { href: 'https://youtube.com/ocanaangelo', target: '_blank' },
	          _react2.default.createElement(_youtube2.default, null),
	          'Youtube'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          A,
	          { href: 'https://facebook.com/angeloocanadev', target: '_blank' },
	          _react2.default.createElement(_facebookSquare2.default, null),
	          'Facebook'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          A,
	          { href: 'https://twitter.com/ocanaangelo', target: '_blank' },
	          _react2.default.createElement(_twitter2.default, null),
	          'Twitter'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SocialLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n  margin-bottom: ', ';\n'], ['\n  margin-top: ', ';\n  margin-bottom: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _BigFirstLetter = __webpack_require__(96);
	
	var _BigFirstLetter2 = _interopRequireDefault(_BigFirstLetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_BigFirstLetter2.default)(_templateObject, function (props) {
	  return props.theme.welcome.marginTop;
	}, function (props) {
	  return props.theme.welcome.marginBottom;
	});
	
	var getWelcomeMsg = function getWelcomeMsg() {
	  return {
	    en: _react2.default.createElement(
	      'p',
	      null,
	      'Hi! Welcome to my site, where you can learn about Web, App and software development.',
	      _react2.default.createElement('br', null),
	      'I welcome you to accept my challenge: ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        ' Study every day '
	      ),
	      ', at least 10 minutes. Do NOT stop learning about tecnology, life, arts, languages, anything that you like.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      'Face your fears! Learning keeps us young, it makes us see the universe in a new perspective and fall in love.',
	      _react2.default.createElement('br', null),
	      'Are you ready to learn and change your life?'
	    ),
	    pt: _react2.default.createElement(
	      'p',
	      null,
	      'Oi! Bem-vindo ao meu site, aqui voc\xEA pode aprender sobre desenvolvimento de aplica\xE7\xF5es Web, Sites e Apps.',
	      _react2.default.createElement('br', null),
	      'Convido voc\xEA a aceitar o meu desafio: ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        ' Estude todos os dias '
	      ),
	      ', pelo menos 10 minutos. N\xC3O pare de estudar sobre tecnologia, vida, artes, idiomas, qualquer coisa que voc\xEA goste.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      'Enfrente seus medos! Aprender nos mant\xE9m jovens, faz-nos ver o universo em uma nova perspectiva e se apaixonar.',
	      _react2.default.createElement('br', null),
	      'Voc\xEA est\xE1 pronto para aprender e mudar sua vida?'
	    ),
	    fr: _react2.default.createElement(
	      'p',
	      null,
	      'Salut! Bienvenue sur mon site, ici vous pouvez en apprendre davantage sur le d\xE9veloppement d\'applications Web.',
	      _react2.default.createElement('br', null),
	      'Je vous invite \xE0 accepter mon d\xE9fi: ',
	      _react2.default.createElement(
	        'mark',
	        null,
	        ' \xC9tudie chaque jour '
	      ),
	      ' au moins 10 minutes. Ne cessez pas d\'\xE9tudier la technologie, la vie, les arts, les langues, tout ce que vous aimez.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      'Faites face \xE0 vos peurs! L\'apprentissage nous garde jeune, nous fait voir l\'univers d\' une nouvelle perspective et nous fait tomber amoureux.',
	      _react2.default.createElement('br', null),
	      '\xCAtes-vous pr\xEAt \xE0 apprendre et \xE0 changer votre vie?'
	    )
	  };
	};
	
	var Welcome = function Welcome(_ref) {
	  var currentLangKey = _ref.currentLangKey;
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    getWelcomeMsg()[currentLangKey]
	  );
	};
	
	Welcome.propTypes = {
	  currentLangKey: _propTypes2.default.string
	};
	
	exports.default = Welcome;
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(9);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PluralsightIcon = function PluralsightIcon(props) {
	  return _react2.default.createElement(
	    _reactIconBase2.default,
	    _extends({ viewBox: '0 0 16 16' }, props),
	    _react2.default.createElement('path', { d: 'M10.48 1.17C6.72-.2 2.54 1.75 1.18 5.5c-1.38 3.8.57 7.97 4.33 9.34 3.77 1.37 7.97-.58 9.34-4.34 1.37-3.78-.58-7.96-4.35-9.33h-.02zM8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8' }),
	    _react2.default.createElement('path', { d: 'M5.95 3.87v8.26L13.12 8 5.95 3.87zm.7 1.18L11.75 8l-5.1 2.95v-5.9' }),
	    _react2.default.createElement('path', { d: 'M4.3 4.77v6.46L9.9 8 4.3 4.77zm.7 1.2L8.54 8 5 10.04V5.96' })
	  );
	};
	
	exports.default = PluralsightIcon;
	module.exports = exports['default'];

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IndexPage = __webpack_require__(118);
	
	var _IndexPage2 = _interopRequireDefault(_IndexPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_IndexPage2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-en-js-c0760f086d112530f9b5.js